<template>
  <div class="bioField">
    <mu-text-field v-model="bio" hintText="Describe yourself" @textOverflow="handleOverflow" :errorText="error"
                   errorColor="red" multiLine fullWidth :rows="3" :rowsMax="6" :maxLength="max"/>
    <div class="bio-buttons">
      <mu-flat-button label="Cancel" @click.native="closeBio"/>
      <mu-flat-button label="Save" @click.native="saveBio" primary :disabled="isBioError"/>
    </div>
  </div>
</template>
<script>
  
  import ProfileApi from "../../../api/Profile"
  import ProfileMixin from "../../../mixins/ProfileMixin"
  import $ from "jquery";
  
  export default {
    name: 'add-profile-bio',
    mixins: [
      ProfileMixin
    ],
    data() {
      return {
        bio: "",
        error: "",
        max: 260
      }
    },
    methods: {
      handleOverflow (isOverflow) {
        let self = this;
        self.error = isOverflow ? `Must be under ${self.max} characters ` : '';
      },
      saveBio() {
        let self = this;
        ProfileApi.saveBio(self.bio).then((response) => {
          if (response.data.error === false) {
            self.closeBio();
            self.$store.state.activeProfileObject.information.basic.bio = self.bio;
            self.$toastr.success("Bio updated");
          }
        }).catch((error) => {
          if (error) {
            self.$toastr.error("There was an error updating your bio");
            self.closeBio();
          }
        });
      },
      closeBio() {
        let self = this;
        self.$emit('bioClosed', 'bio');
      }
    },
    computed: {
      isBioError() {
        let self = this;
        return self.bio !== null && self.bio.length >= self.max;
      }
    },
    mounted() {
      let self = this;
      self.bio = self.getProfile().information.basic.bio;
      $('.bioField textarea').focus();
    }
  }

</script>



// WEBPACK FOOTER //
// AddProfileBio.vue?25772c95